import script from "./EmployeeUpdateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeUpdateDialog.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeUpdateDialog.vue?vue&type=style&index=0&id=05704c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05704c66"]])

export default __exports__